import React, { useState, useEffect, FC } from 'react';
import KickImage from 'Reuseables/KickImage';

// Actions
import { sliderBanner, sliderItemClick } from '../../../actions/slidersAction';
import { connect } from 'react-redux';

// Sliders
import Slider from 'react-slick';
import styled from 'styled-components';

//Analytics
import Analytics from '../../../services/Analytics';

// Utils
import { getCloudImageUrl, getFileExt } from '../../../utils';

// Images
import SliderLeftTrans from '../../../images/slider-left-trans.png';
import SliderRightTrans from '../../../images/slider-right-trans.png';
import SliderLeftHovered from '../../../images/slider-left-hovered.png';
import SliderRightHovered from '../../../images/slider-right-hovered.png';

interface PreviousArrowSlider {
  className: string;
  style: Object;
  onClick: () => any;
}

const PrevSlide: FC<PreviousArrowSlider> = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    left: 30px !important;
    &::before {
      content: '' !important;
    }
    &:hover {
      opacity: 1;
    }
    img {
      width: 40px !important;
      position: absolute;
      left: 100px !important;
      height: 40px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
    }
    opacity: 0.5;

    @media (max-width: 480px) {
      display: none;
      img {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        left: -5px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        left: '40px !important',
        width: '40px',
        height: '40px',
        display: window.screen.availWidth > 480 ? 'block' : 'none',
      }}
      onClick={onClick}
    >
      <KickImage src={SliderLeftHovered} alt="..." />
    </LeftArrow>
  );
};

interface NextSlide {
  className: string;
  style: Object;
  onClick: () => any;
}

const NextSlide: FC<NextSlide> = (props: NextSlide) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: '' !important;
    }
    &:hover {
      opacity: 1;
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      right: 0px;
      position: absolute;
    }
    opacity: 0.5;
    @media (max-width: 480px) {
      img {
        right: 5px;
        width: 30px !important;
        height: 30px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        display: window.screen.availWidth > 480 ? 'block' : 'none',
        width: '40px',
        height: '40px',
      }}
      onClick={onClick}
    >
      <KickImage src={SliderRightHovered} alt="..." />
    </LeftArrow>
  );
};

let settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  swipe: true,
  prevArrow: <PrevSlide />,
  nextArrow: <NextSlide />,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

interface SliderImagesItem {
  redirect_url: string;
  img_url: string;
  name: string;
  images: Array<Object>;
  id: number;
}

interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

type HomepageSlider = {
  history: History;
  sliderBanner: (args: Object) => any;
  sliderItemClick: (args: Object) => any;
  category: string;
  dataCategory: string;
  sliderImages: Array<SliderImagesItem>;
  isCountdownActive: boolean;
  dataAuth: Array<Object>;
};

const HomepageSlider: FC<HomepageSlider> = ({
  history,
  sliderBanner,
  category,
  dataCategory,
  sliderImages,
  isCountdownActive,
  sliderItemClick,
  dataAuth,
}) => {
  useEffect(() => {
    // Required parameter for fetching slider data
    const params = { params: { category: dataCategory } };
    // Fetch slider for banner
    sliderBanner(params);
  }, [category]);

  function _redirectAfterClick(url: string, id: number) {
    // Redirect onClick slider
    window.open(url);
    _handleSliderClick(id);
  }

  function _handleSliderClick(id: number) {
    const { isLogged, userdata } = dataAuth;
    const payload = {
      slider_id: id,
      action: 'SLIDER_ITEM_CLICK',
      user_id: isLogged ? userdata.id : null,
      app_os: 'Web',
    };

    const sliderProperties = {
      userId: isLogged ? userdata.id : 'Anonymous',
      app_os: 'Web',
      slider_id: id,
    };

    sliderItemClick(payload);
    Analytics.recordSliders('slider_item_click', sliderProperties);
  }

  interface Slide {
    orientation: string;
  }

  if (sliderImages.length === 1) {
    settings = {
      ...settings,
      autoplay: false,
      arrows: false,
    };
  }

  if (window.screen.availWidth < 480) {
    // Display slider for mobile screen
    return (
      <Slider {...settings}>
        {sliderImages.map((item: SliderImagesItem) => {
          // Map through array of slides
          if (
            item &&
            item.images &&
            item.images.find((item: Slide) => (item.orientation = 'portrait'))
          ) {
            let images = item.images.find(
              (slide: Slide) => slide.orientation === 'portrait',
            );
            const isGifImage = getFileExt(images?.URL) === 'gif';
            return (
              <div className="homepage__slider">
                <KickImage
                  onClick={() =>
                    _redirectAfterClick(item.redirect_url, item.id)
                  }
                  isGifImage={isGifImage}
                  noCompress
                  //handle render gif without getCloudImageUrl
                  src={images?.URL}
                  alt={item.name}
                />
              </div>
            );
          } else {
            return null;
          }
        })}
      </Slider>
    );
  }
  // Display slider for desktop screen
  return (
    <Slider {...settings}>
      {sliderImages.map((item: SliderImagesItem) => {
        const isGifImage = getFileExt(item.img_url) === 'gif';
        // Map through array of slides
        return (
          <div className="homepage__slider">
            <KickImage
              onClick={() => _redirectAfterClick(item.redirect_url, item.id)}
              //handle render gif without getCloudImageUrl
              src={
                isGifImage
                  ? item.img_url
                  : getCloudImageUrl(item.img_url, 3000, 'carousel')
              }
              alt={item.name}
            />
          </div>
        );
      })}
    </Slider>
  );
};

interface ImageUrl {
  URL: string;
}

interface SliderImagesItem {
  redirect_url: string;
  img_url: string;
  name: string;
  images: Array<ImageUrl>;
}

interface Category {
  selected: string;
}
interface Images {
  images: Array<Object>;
}
interface Menu {
  countdown_modal: boolean;
}
interface State {
  sliderHome: Images;
  dataCategory: Category;
  dataMenu: Menu;
}

const mapStateToProps = (state: State) => ({
  sliderImages: state.sliderHome.images,
  dataCategory: state.dataCategory.selected,
  isCountdownActive: state.dataMenu.countdown_modal,
});

const mapDispatchToProps = (dispatch: any) => ({
  sliderBanner: (payload: Object) => dispatch(sliderBanner(payload)),
  sliderItemClick: (payload: Object) => dispatch(sliderItemClick(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomepageSlider);
